import React from 'react';
import PropTypes from 'prop-types';

const RoundProgress = ({ percentuale }) => {
  const radius = 20;
  const stroke = 2;
  const progress = percentuale;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - progress / 100 * circumference;
  return (
    <span>
      <svg
        height={radius * 2}
        width={radius * 2}
      >
        <circle
          className=""
          stroke="#eaeaea"
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={`${circumference} ${circumference}`}
          style={{ strokeDashoffset: 0 }}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          className="progressRing__circle"
          stroke="white"
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={`${circumference} ${circumference}`}
          style={{ strokeDashoffset }}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
      </svg>
    </span>
  );
};

RoundProgress.propTypes = {
  percentuale: PropTypes.number.isRequired,
};

export default RoundProgress;
